import { Button, Typography, Row, Col } from 'antd';
import React from 'react';
import styles from './permission-denied-page.module.sass';
import { BuildTwoTone } from '@ant-design/icons';

const PermissionDeniedPage = (props) => {
  const { Title, Text } = Typography;

  return (
    <Row gutter={24}>
      <Col xs={24}>
        <div className={styles.permission_denied_page}>
          <BuildTwoTone className={styles.icon} />
          <Title level={2}>It's time to upgrade</Title>
          <Text>You have reached the limit of your current plan.</Text>
          <Text>Contact us to subscribe to a higher plan.</Text>
          <Button
            type="primary"
            onClick={
              () => (window.location.href = 'mailto:sales@silentpush.com')
              //() => window.open('https://silentpush.com/upgrade-purchase')
            }
          >
            Contact Us
          </Button>
        </div>
      </Col>
    </Row>
  );
};

export default PermissionDeniedPage;
